export const RecordBrowserActions = {
    GLOBAL_LOOKUP_CLICK: "record-browser/global-lookup-click",
};

export default RecordBrowserActions;



// WEBPACK FOOTER //
// ./app/data/RecordBrowserActions.js